import { createContext } from "react";

const TransactionsScreen = createContext<any>(null);

export default TransactionsScreen;
